import React from 'react';
import { App as CapApp } from '@capacitor/app';
import type { PluginListenerHandle } from '@capacitor/core';

import { isNativeApp } from '../../utils/appLinks';

export function useAppResume({
  requestAutoRefresh,
}: {
  requestAutoRefresh: (reason: 'visibility' | 'focus' | 'app-resume') => void;
}) {
  React.useEffect(() => {
    if (!isNativeApp()) return;
    let sub: PluginListenerHandle | null = null;
    let cancelled = false;
    let resumeTimer: ReturnType<typeof setTimeout> | null = null;

    const handleResume = () => {
      if (cancelled) return;
      resumeTimer = setTimeout(() => {
        if (cancelled) return;
        requestAutoRefresh('app-resume');
      }, 100);
    };

    const setupListener = async () => {
      try {
        sub = await CapApp.addListener('appStateChange', (state) => {
          if (state.isActive) {
            handleResume();
          }
        });
      } catch {}
    };

    void setupListener();
    return () => {
      cancelled = true;
      if (resumeTimer != null) clearTimeout(resumeTimer);
      if (sub) {
        void sub.remove();
      }
    };
  }, [requestAutoRefresh]);
}
